import React, { useRef, useState, useEffect, useContext } from "react";
import "./Contact.css";
import { BsTelephone } from "react-icons/bs";
import { TfiEmail } from "react-icons/tfi";
import { SlLocationPin } from "react-icons/sl";
import { FaWhatsapp, FaPaperPlane, FaUser, FaUserAlt, FaEnvelope, FaComments, FaHandHoldingHeart } from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";
import { LanguageContext, getTranslation } from "../LanguageContext";

// Objeto de traducciones para el componente Contact
const contactTranslations = {
  en: {
    contactUs: "Contact Us",
    contactInfo: "Contact Information",
    headquarters: "Siege:195 bd moufdi zakaria hay almouna Berrechid - Maroc",
    annex: "Annex: contre Al Amel pour les enfants abondonnées cartier administrative lotissement Taminya Settat",
    donate: "Donate",
    contactForm: "Contact Form",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    message: "How can we help you?",
    send: "Send Message",
    emptyFields: "Please fill in all fields",
    successMessage: "Your message has been sent successfully",
    invalidEmail: "The email is invalid"
  },
  fr: {
    contactUs: "Contactez nous",
    contactInfo: "Information de Contact",
    headquarters: "Siege:195 bd moufdi zakaria hay almouna Berrechid - Maroc",
    annex: "Annex: contre Al Amel pour les enfants abondonnées cartier administrative lotissement Taminya Settat",
    donate: "Donner",
    contactForm: "Contact form",
    firstName: "Prénom",
    lastName: "Nom",
    email: "E-mail",
    message: "Que pouvons-nous vous aider ?",
    send: "Envoyer Message",
    emptyFields: "Veuillez remplir tous les champs",
    successMessage: "Votre message a été envoyé avec succès",
    invalidEmail: "L'email est faux"
  },
  ar: {
    contactUs: "اتصل بنا",
    contactInfo: "معلومات الاتصال",
    headquarters: "Siege:195 bd moufdi zakaria hay almouna Berrechid - Maroc",
    annex: "Annex: contre Al Amel pour les enfants abondonnées cartier administrative lotissement Taminya Settat",
    donate: "تبرع",
    contactForm: "نموذج الاتصال",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    message: "كيف يمكننا مساعدتك؟",
    send: "إرسال الرسالة",
    emptyFields: "يرجى ملء جميع الحقول",
    successMessage: "تم إرسال رسالتك بنجاح",
    invalidEmail: "البريد الإلكتروني غير صحيح"
  }
};

const Contact = () => {
  const prenomRef = useRef();
  const nomRef = useRef();
  const emailRef = useRef();
  const messageRef = useRef();
  const [isWideScreen, setIsWideScreen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Usar el contexto de idioma
  const { language } = useContext(LanguageContext);
  
  // Función para obtener la traducción
  const translate = (key) => getTranslation(contactTranslations, language, key);
  
  // Determinar si el texto debe fluir de derecha a izquierda (para árabe)
  const isRTL = language === 'ar';

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 800);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial value

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const ValidatContact = () => {
    const firstName = prenomRef.current.value;
    const lastName = nomRef.current.value;
    const email = emailRef.current.value;
    const message = messageRef.current.value;

    if (firstName === "" || lastName === "" || email === "" || message === "") {
      alert(translate('emptyFields'));
      return;
    }
    
    setIsSubmitting(true);

    const contact = {
      firstName,
      lastName,
      email,
      message,
    };
    
    axios
      .post("http://localhost:4444/contact/upload", contact)
      .then((res) => {
        alert(translate('successMessage'));
        // empty the input fields
        prenomRef.current.value = "";
        nomRef.current.value = "";
        emailRef.current.value = "";
        messageRef.current.value = "";
        setIsSubmitting(false);
      })
      .catch((err) => {
        alert(translate('invalidEmail'));
        setIsSubmitting(false);
      });
  };

  return (
    <div className={`contact ${isRTL ? 'rtl' : ''}`} id="contact">
      <div className="contact_One">
        <h1>{translate('contactUs')}</h1>
        <h2>{translate('contactInfo')}</h2>
        <p className="contact_p">
          <span className="contact_span">
            <SlLocationPin />
            <a
              className="link_a"
              href="https://maps.app.goo.gl/KyxaXNjAQxhig8Xy8"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Headquarters location"
            >
              {translate('headquarters')}
            </a>
          </span>

          <span className="contact_span">
            <SlLocationPin />
            <a
              className="link_a"
              href="https://maps.app.goo.gl/Sec3q3q4NWL9rmWm7"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Annex location"
            >
              {translate('annex')}
            </a>
          </span>
        </p>
        <p>
          <span>
            <BsTelephone />
          </span>
          <a
            className="link_a"
            href="tel:+212606713477"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Phone number"
          >
            +2126 06 71 3477
          </a>
        </p>
        <p>
          <span>
            <FaWhatsapp />
          </span>
          <a
            className="link_a"
            href="https://wa.me/212606713477"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp contact"
          >
            +2126 06 71 3477
          </a>
        </p>
        {isWideScreen ? (
          <p>
            <span>
              <TfiEmail />
            </span>
            <a
              className="link_a"
              href="https://mail.google.com/mail/?view=cm&fs=1&to=anpemaroc@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Email address"
            >
              anpemaroc@gmail.com
            </a>
          </p>
        ) : (
          <p>
            <span>
              <TfiEmail />
            </span>
            <a
              className="link_a"
              href="intent://compose?to=anpemaroc@gmail.com#Intent;scheme=mailto;package=com.google.android.gm;end"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Email address mobile"
            >
              anpemaroc@gmail.com
            </a>
          </p>
        )}
        <Link to="/donner">
          <button>
            <FaHandHoldingHeart />
            {translate('donate')}
          </button>
        </Link>
      </div>
      <div className="contact_Two">
        <h1>{translate('contactForm')}</h1>
        <div className="Prenom_Name">
          <div className="input-wrapper">
            <FaUserAlt className="input-icon" />
            <input 
              ref={prenomRef} 
              type="text" 
              placeholder={translate('firstName')} 
              aria-label={translate('firstName')} 
              className="input-field"
            />
          </div>
          <div className="input-wrapper">
            <FaUser className="input-icon" />
            <input 
              ref={nomRef} 
              type="text" 
              placeholder={translate('lastName')} 
              aria-label={translate('lastName')} 
              className="input-field"
            />
          </div>
        </div>
        <div className="input-wrapper">
          <FaEnvelope className="input-icon" />
          <input
            ref={emailRef}
            type="email"
            placeholder={translate('email')}
            pattern="[^ @]*@[^ @]*"
            className="input-field"
            aria-label={translate('email')}
          />
        </div>
        <div className="input-wrapper">
          <FaComments className="input-icon textarea-icon" />
          <textarea
            ref={messageRef}
            placeholder={translate('message')}
            aria-label={translate('message')}
            className="input-field textarea"
          />
        </div>
        <button 
          onClick={ValidatContact} 
          disabled={isSubmitting}
          className={isSubmitting ? 'submitting' : ''}
        >
          <FaPaperPlane />
          {translate('send')}
        </button>
      </div>
    </div>
  );
};

export default Contact;
